import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../../web/ReactQueryProvider';
import { getErrorMessage } from '../../../admin/containers/adsMeta/utils';
import { IMetaConnectionState, IUnassignManagedRequest } from './types';
import { META_CONNECTION_QUERY_KEY } from './useMetaConnectionQuery';
import { META_VISIBLE_ASSETS_QUERY_KEY } from './useMetaVisibleAssetsQuery';

// Same `ManagedConnectionResponse` subset as the assign mutation.
type ManagedConnectionResponse = Pick<
	IMetaConnectionState,
	'levitateAccountId' | 'managedAdAccountIds' | 'hasCustomerToken'
>;

// DELETE admin/ads/meta/connections/{levitateAccountId}/managed/{metaAdAccountId}
export function useMetaUnassignManagedMutation() {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ levitateAccountId, metaAdAccountId }: IUnassignManagedRequest) =>
			userSession.webServiceHelper.callAsync<ManagedConnectionResponse>(
				`admin/ads/meta/connections/${encodeURIComponent(levitateAccountId)}/managed/${encodeURIComponent(metaAdAccountId)}`,
				'DELETE'
			),
		onSuccess: (data, variables) => {
			reactQueryClient.setQueryData<IMetaConnectionState | undefined>(
				[META_CONNECTION_QUERY_KEY, variables.levitateAccountId],
				prev => (prev ? { ...prev, ...data } : data)
			);
			reactQueryClient.invalidateQueries({ queryKey: [META_VISIBLE_ASSETS_QUERY_KEY] });
		},
		onError: error => {
			toast.error(getErrorMessage(error) || "Couldn't remove the managed ad account.");
		},
	});
}
